/**
 * @file Parent-board linked-item API wrappers.
 */

import { updateTaskLinkageCallable as configuredUpdateTaskLinkageCallable } from "../../app/firebase/callables.js";

/**
 * Creates linked-item helpers.
 * @param {object} deps Dependency bag.
 * @param {Function} deps.updateTaskLinkageCallable Callable wrapper.
 * @returns {object} Linked-item API helpers.
 */
export function createLinkedItemsApi({ updateTaskLinkageCallable }) {
    /**
     * Updates a task linkage through the existing backend callable.
     * @param {object} payload Callable payload.
     * @returns {Promise<object>} Callable response data.
     */
    const updateTaskLinkage = async (payload) => {
        const result = await updateTaskLinkageCallable(payload);
        return result.data;
    };

    return { updateTaskLinkage };
}

const configuredLinkedItemsApi = createLinkedItemsApi({
    updateTaskLinkageCallable: configuredUpdateTaskLinkageCallable,
});

export const updateTaskLinkage = configuredLinkedItemsApi.updateTaskLinkage;
